import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { DialogRoute, RouteStore } from 'bernie-core';
import { Layer } from 'bernie-view';

import { UitkDialogContent, UitkFullscreenDialog } from 'uitk-react-dialog';
import { UitkFloatingActionButton } from 'uitk-react-button';
import { UitkToolbar } from 'uitk-react-toolbar';

const TrackedIconToggleInputLike = ClickTracker(UitkFloatingActionButton);
const TrackedIconToggleInputDislike = ClickTracker(UitkFloatingActionButton);

export interface ChatBotSurveyProps {
  closeLabel: string;
  feedbackContent: string;
  feedbackTitle: string;
  routeStore?: RouteStore;
}

@inject('routeStore')
@observer
export class ChatBotSurvey extends React.Component<ChatBotSurveyProps> {
  constructor(props) {
    super(props);

    this.closeExitSurvey = this.closeExitSurvey.bind(this);
  }

  private closeExitSurvey() {
    if (this.props.routeStore) {
      this.props.routeStore.goBack();
    }
  }

  public render() {
    const { closeLabel, feedbackContent, feedbackTitle } = this.props;

    return (
      <DialogRoute id="exit-survey">
        <Layer id="exit-survey-dialog" onDismiss={this.closeExitSurvey}>
          <div className="exit-survey">
            <UitkFullscreenDialog dialogShow={true}>
              <UitkToolbar action={this.closeExitSurvey} header={feedbackTitle} iconLabel={closeLabel} />
              <UitkDialogContent>
                <section className="search-form-overlay-main uitk-type-center">
                  {feedbackContent}
                  <table className="bot-feedback-table">
                    <tr>
                      <td>
                        <TrackedIconToggleInputLike
                          icon="thumb_up"
                          className="thumb-icon-toggle"
                          id="thumbup"
                          onClick={this.closeExitSurvey}
                          linkName="VR Feedback Like"
                          rfrr="VRBotFeedback.Like"
                        />
                      </td>
                      <td>
                        <TrackedIconToggleInputDislike
                          icon="thumb_up"
                          className="thumb-icon-toggle vrbot-icon-rotate"
                          id="thumbdown"
                          onClick={this.closeExitSurvey}
                          linkName="VR Feedback Dislike"
                          rfrr="VRBotFeedback.Dislike"
                        />
                      </td>
                    </tr>
                  </table>
                </section>
              </UitkDialogContent>
            </UitkFullscreenDialog>
          </div>
        </Layer>
      </DialogRoute>
    );
  }
}
